import e from"./SortBy.vue_vue&type=script&lang.js";import{render as t}from"./SortBy.vue_vue&type=template&id=b69b3b76&lang.js";e.render=t,e.__file="src/components/SortBy.vue";export default e;
//# sourceMappingURL=SortBy.vue.js.map
